export default __webpack_public_path__ + "static/media/worksthing-chime.84e23d2a.mp3";